import { DetailedHTMLProps, forwardRef, Ref, HTMLAttributes } from 'react';
import Icon, { IconTheme, IconVariant } from 'src/components/ui-kit/icon/icon';
import { OrderByDirection } from 'src/enums/order-by-direction';
import classNames from 'classnames/bind';
import styles from './table.module.scss';

const classesContext = classNames.bind(styles);

function ListingsTableHeaderAction(
  {
    direction,
    children,
    ...restProp
  }: { direction?: OrderByDirection } & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
  ref: Ref<HTMLDivElement>
): JSX.Element {
  return (
    <div
      className={styles.table_header_action}
      ref={ref}
      {...restProp}>
      {children}
      <span
        className={classesContext([
          'table_header_icon',
          {
            table_header_icon__asc: direction === OrderByDirection.ASC,
            table_header_icon__desc: direction === OrderByDirection.DESC
          }
        ])}
      >
        <Icon
          variant={IconVariant.DROPDOWN}
          theme={IconTheme.WHITE} />
      </span>
    </div>
  );
}

export default forwardRef(ListingsTableHeaderAction);
